
export default {
  getCurrentTeam (state) {
    return state.currentTeam
  }
}
